import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CertIcon = styled('img')<{ isVertical?: boolean }>(
  ({ theme, isVertical }) => `
  ${theme.breakpoints.down('md')} {
    width: ${isVertical ? '16px' : '10px'};
    height: ${isVertical ? '16px' : '10px'};
    position: relative;
    left: 4px;
  }
  position: relative;
  left: 6px;
  width: 16px;
  height: 16px;
`,
);

export const CertBox = styled(Box)(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 17.54px;
  padding: 0 10.3px;
  font-size: 12px;
  ${theme.breakpoints.up('md')} {
    height: 30px;
  }
`,
);

export const CertCourseBoxDesktop = styled(CertBox)`
  div {
    font-weight: bold;
  }
  height: 30px;
  background-color: #1e8764;
  color: white;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  width: 130px;

  @media only screen and (max-width: 767px) {
    width: 76px;
    height: 17.54px;
    margin-top: 8px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .text-cert {
    font-size: 1rem;

    @media only screen and (max-width: 767px) {
      font-size: 9px;
      line-height: 9px;
    }
  }
`;
